import React from 'react';

import { removeUnderscoreToCapitalize } from '../../helpers/FormattingHelpers';
import { isNonNullable } from '../../helpers/TypingHelpers';
import { CompleteScanOrBoxModal, ModalContent } from '../../types/Modal';

export const getCompleteScanOrBoxContent = (data: CompleteScanOrBoxModal): ModalContent => {
    // If box is populated, we are completing a box
    const boxId = data.box?.id;

    return {
        type: data.pendingLoggersCount ? 'INFORMATION' : 'CONFIRMATION',
        confirmBtnColor: data.warnAboutInspect && data.inspectLoggersCount ? 'YELLOW' : 'GREEN',
        header: `Complete ${boxId ? 'box' : 'scan'} with ID: ${boxId ?? data.scan?.id}`,

        body: (
            <div className="complete-modal-body">
                {data.pendingLoggersCount ? (
                    <strong>Please remove pending loggers from the scan and try again.</strong>
                ) : (
                    <>
                        {data.warnAboutInspect && !!data.inspectLoggersCount && (
                            <div className="warning-text">
                                Scan contains {data.inspectLoggersCount} loggers with status inspect.
                            </div>
                        )}
                        <div>
                            <span className="margin-right">You have scanned:</span>
                            <strong>{getScannedItemsText(data)}</strong>
                        </div>
                        <div>
                            Scan type:{' '}
                            <strong>
                                {removeUnderscoreToCapitalize(data.scan?.scanTypeName ?? data.box?.scanTypeName)}
                            </strong>
                        </div>
                        {data.scan && (
                            <>
                                <div>
                                    Tracking ID:{' '}
                                    <strong>{data.scan.trackingId ? data.scan.trackingId : 'No tracking ID'}</strong>
                                </div>

                                <div>
                                    Sales order ID:{' '}
                                    <strong>
                                        {data.scan.salesOrderId ? data.scan.salesOrderId : 'No sales order ID'}
                                    </strong>
                                </div>
                            </>
                        )}
                        <div>
                            <strong>Are you sure you want to complete the {boxId ? 'box' : 'scan'}?</strong>
                        </div>
                    </>
                )}
            </div>
        )
    };
};

const getScannedItemsText = (_data: CompleteScanOrBoxModal) => {
    // If scannedLoggersCount is populated, we are completing a scan or a box
    const scanOrBoxLoggerCount = _data.scannedLoggersCount;
    if (isNonNullable(scanOrBoxLoggerCount)) {
        return `${scanOrBoxLoggerCount} logger${scanOrBoxLoggerCount === 1 ? '' : 's'}`;
    }

    // We have a box scan and scanOrBoxLoggerCount is not populated, so we return the box count
    if (_data.scan.isBoxScan) {
        const boxCount = _data.scan.boxes?.length ?? 0;
        return `${boxCount} box${boxCount === 1 ? '' : 'es'}`;
    }

    return 'N/A';
};
